import React from 'react'
import Grid from "@material-ui/core/Grid";
import WhiteHeaderCard from "../../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {shouldAuthenticate} from "../../../../utils/guard";
import ServizioClientiPremiumCard from "../../../cards/servizio-clienti-premium-card/ServizioClientiPremiumCard";
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../colors";
import {useMediaQuery} from "@material-ui/core";
import {useSelector} from "react-redux";

const useStyles = makeStyles({
    cardContent: {
        color: colors.font.light,
    },
    contentOverline: {
        fontSize: "0.75rem",
    },
    cardContentWithoutButton: {
        minHeight: "200px",
    },
    breakWord: {
        wordBreak: "break-word",
    },
    maxWidth: {
        width: "100%",
    },
});

const RichiediAssistenzaDeviceCards = (props) => {
    const classes = useStyles();
    const smScreen = useMediaQuery("(max-width: 450px)");
    const userClaims = useSelector(state => state.authReducer.userClaims);
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany);

    return (
        <React.Fragment>
            <Grid container spacing={4}>
                <Grid item xs={12} md={6} lg={4}>
                    <WhiteHeaderCard elevationValue={props.elevationValue}
                                     title={"Guasto terminale"}>
                        <div className={classes.cardContentWithoutButton}>
                            <Typography variant="body2" className={classes.cardContent}>
                                Se hai bisogno di riparare o sostituire un terminale non esitare a contattarci
                            </Typography>
                        </div>
                        <Button
                            disabled={!shouldAuthenticate("C", userClaims.typeUser, userClaims.roles)}
                            className={smScreen ? classes.maxWidth : null}
                            variant={"outlined"} color={"secondary"}
                            onClick={() => props.setGuastoTerminale()}>
                            Contattaci
                        </Button>
                    </WhiteHeaderCard>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <WhiteHeaderCard elevationValue={props.elevationValue}
                                     title={"Furto o smarrimento"}>
                        <div className={classes.cardContentWithoutButton}>
                            <Typography variant="body2" className={classes.cardContent}>
                                In caso di furto o smarrimento del tuo terminale non esitare a contattarci
                            </Typography>
                        </div>
                        <Button
                            variant={"outlined"}
                            color={"secondary"}
                            onClick={() => props.setFurtoSmarrimento()}
                            disabled={!shouldAuthenticate("C", userClaims.typeUser, userClaims.roles)}
                            className={smScreen ? classes.maxWidth : null}
                        >
                            Contattaci
                        </Button>
                    </WhiteHeaderCard>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <ServizioClientiPremiumCard elevationValue={props.elevationValue}
                                                data={selectedCompany}/>
                </Grid>
            </Grid>

        </React.Fragment>
    )
}


export default RichiediAssistenzaDeviceCards;
